import { Component, Input, OnInit } from '@angular/core';

import { Storyboard } from 'app/models/storyboard';
import { File } from 'app/models/file';
import { FileType } from 'app/models/file-type.enum';
import { GoogleTagManagerService } from '../../../services/google-tag-manager.service';

@Component({
  selector: 'app-storyboard-item',
  templateUrl: './storyboard-item.component.html',
  styleUrls: ['./storyboard-item.component.scss']
})
export class StoryboardItemComponent implements OnInit {
  @Input() storyboard: Storyboard;

  constructor(private gtmService: GoogleTagManagerService) {}

  ngOnInit() {}

  SendStoryboardEvent() {
    this.gtmService.pushEvent('Storyboard - Open panel');
  }

  get thumbnailFile(): File | null {
    if (!this.storyboard?.files?.length) return null;

    // If admin explicitly chose a thumbnail, use that
    if (this.storyboard.thumbnailFileId) {
      const chosen = this.storyboard.files.find(f => f.id === this.storyboard.thumbnailFileId);
      if (chosen) return chosen;
    }

    // Auto-fallback: first video, then first image (case-insensitive)
    return this.storyboard.files.find(f => (f.contentType || '').toUpperCase() === FileType.Video || (f.source || '').toUpperCase() === 'VIDEO')
        || this.storyboard.files.find(f => (f.contentType || '').toUpperCase() === FileType.Img || (f.source || '').toUpperCase() === 'IMG')
        || null;
  }

  get isVideo(): boolean {
    const ct = (this.thumbnailFile?.contentType || '').toUpperCase();
    const src = (this.thumbnailFile?.source || '').toUpperCase();
    return ct === FileType.Video || src === 'VIDEO';
  }
}
